<template>
    <templateList :type="3"/>
</template>

<script>
import templateList from './templateList.vue'
let timer = null
export default {
    name: 'myChoice',
    components: {
        templateList,
    },
}
</script>
